// test4ReactionStrike.js - Wolf Motor Function Test (WMFT Timed Tasks) HUD

import { CLINICAL_REACTION_TARGET_RADIUS } from "../../../constants";

export function drawTest4Reaction(ctx, w, h, targetPos, trialIdx, trialsTotal, isHit, hitMsg, testColor) {
  ctx.save();
  if (targetPos) {
    const tx = targetPos.x * w;
    const ty = targetPos.y * h;
    const r = CLINICAL_REACTION_TARGET_RADIUS * Math.min(w, h);

    const pulse = Math.sin(Date.now() / 180);
    const auraR = r * (1.35 + 0.1 * pulse);
    const auraG = ctx.createRadialGradient(tx, ty, r * 0.3, tx, ty, auraR);
    auraG.addColorStop(0, "rgba(14,136,235,0.35)");
    auraG.addColorStop(1, "transparent");
    ctx.beginPath();
    ctx.arc(tx, ty, auraR, 0, Math.PI * 2);
    ctx.fillStyle = auraG;
    ctx.fill();

    ctx.beginPath();
    ctx.arc(tx, ty, r, 0, Math.PI * 2);
    ctx.fillStyle = isHit ? "#10b981" : (testColor || "#0e88eb");
    ctx.shadowColor = isHit ? "#10b981" : (testColor || "#0e88eb");
    ctx.shadowBlur = 20;
    ctx.fill();
    ctx.shadowBlur = 0;
    ctx.lineWidth = 3;
    ctx.strokeStyle = "#fff";
    ctx.stroke();

    ctx.font = `${Math.round(r * 0.9)}px Inter`;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillStyle = "#fff";
    ctx.fillText("⚡", tx, ty);
  }

  const trialText = `Trial ${trialIdx + 1} / ${trialsTotal}`;
  ctx.font = "bold 11px Inter, sans-serif";
  const tW = ctx.measureText(trialText).width + 18;
  ctx.fillStyle = "rgba(8,12,24,0.75)";
  ctx.beginPath();
  ctx.roundRect(w * 0.5 - tW / 2, h * 0.05, tW, 22, 6);
  ctx.fill();
  ctx.fillStyle = "#94a3b8";
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText(trialText, w * 0.5, h * 0.05 + 11);

  if (hitMsg) {
    const badgeText = `⚡ STRIKE! ${hitMsg}`;
    ctx.font = "bold 12px Inter, sans-serif";
    const bW = ctx.measureText(badgeText).width + 20;
    ctx.fillStyle = "rgba(16, 185, 129, 0.92)";
    ctx.beginPath();
    if (ctx.roundRect) {
      ctx.roundRect(w * 0.5 - bW / 2, h * 0.11, bW, 24, 6);
    } else {
      ctx.rect(w * 0.5 - bW / 2, h * 0.11, bW, 24);
    }
    ctx.fill();
    ctx.fillStyle = "#ffffff";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(badgeText, w * 0.5, h * 0.11 + 12);
  }

  ctx.restore();
}
